import { ConfirmationAirEntryDrawer } from "./ConfirmationAirEntryDrawer";
import type { ConfirmationEntryProps } from "./types";

/** 船票使用独立草稿实例，复用人工路线、原行身份与主体设置交互。 */
export function ConfirmationShipEntryDrawer(props: Omit<ConfirmationEntryProps, "category">) {
  return <ConfirmationAirEntryDrawer {...props} mode="ship" />;
}
